import {useState, useEffect, useMemo} from "react";
import {Link as RouterLink, useParams, useNavigate, useLocation} from "react-router-dom";
import {
  Button,
  Container,
  Grid,
  Stack,
  Typography,
  TextField,
  Chip,
  Checkbox,
  Select,
  OutlinedInput,
  MenuItem,
  useTheme,
  FormControl,
  FormControlLabel,
  FormLabel,
  RadioGroup,
  Radio,
  Paper,
  Tabs,
  Tab,
  Box,
  Switch
} from "@mui/material";
// components
import StringUtil from "src/utils/StringUtil";
import {alert} from "src/services/alert";
import {COMP_NAME} from "src/config/constants";
import FormItem from "src/components/form-item/FormItem";
import Uploader from "src/components/uploader/Uploader";
import {useSelector} from "react-redux";
// import { getProductCategories } from "src/services/request";
import PriceList from "src/components/PriceList";
import MyEditor from "src/components/editor/MyEditor";
import {TabContext, TabList, TabPanel} from "@mui/lab";
import {getStoreBrands, getStoreSections, getSuppliers} from "src/services/request";
import {asyncRequest} from "src/services/network";
import FormDialog from "src/components/common/FormDialog";
import MerchantPicker from "src/components/common/MerchantPicker";
import CouponPicker from "src/components/common/CouponPicker";
import SupplierPicker from "src/components/common/SupplierPicker";
import axios from "axios";

const TABS = [{label: "基本信息"}, {label: "规格库存"}, {label: "商品详情"}, {label: "物流设置"}, {label: "营销设置"}, {label: "支付方式"}];

export default function ProductEdit({open, item, action, onClose, onFinish}) {
  const categoriesTwo = useSelector((state) => state.globalData.productCategories) || [];
  const {storeSections, storeBrands, suppliers} = useSelector((state) => state.globalData);
  const navigate = useNavigate();
  const {id} = item;
  const [categoriesNew, setCategoriesNew] = useState([]);
  const [filter, setFilter] = useState({
    categoryId: "",
    subCategoryId: "",
  });
  const [couponTypeList, setCategoryList] = useState([]);
  const [transferList, setTransferList] = useState([]);

  const [detail, setDetail] = useState(item.detail);
  const [merchant, setMerchant] = useState(item.merchant || {});
  const [categorySearch, setCategorySearch] = useState('');
  const [openCategorySelect, setOpenCategorySelect] = useState(false);

  const [tabIdx, setTabIdx] = useState("0");
  const [coupons, setCoupons] = useState([]);
  const [supplier, setSupplier] = useState({});
  const [form, setForm] = useState({
    mid: item.mid,
    intro: item.intro || "",
    name: item.name || "",
    attrName: item.attrName || "",
    attrs: item.attrs || null,
    priceList: item.priceList || null,
    cover: item.cover || "",
    // coverHorizontal: item.coverHorizontal || "",
    images: item.images || "",
    categoryId: item.categoryId || 0, // 分类
    subCategoryId: item.subCategoryId || 0, // 二级分类
    priceOriginal: item.priceOriginal || "",
    price: item.price || "",
    supplierCost: item.supplierCost || "",
    cost: item.cost || "",
    supplyChainFee: item.supplyChainFee || "",
    unit: item.unit || "件",
    status: item.status || 1,
    shippingType: item.shippingType || 1,
    shippingFee: item.shippingFee || "",
    stock: item.stock || "",
    specType: item.specType || 0,
    points: item.points || 0,
    order: item.order || 0,
    // zhitui: item.zhitui || 0,
    isRetail: item.isRetail != undefined ? item.isRetail : true,
    isBulk: item.isBulk != undefined ? item.isBulk : false,
    isSelected: item.isSelected || false,
    // jiantui: item.jiantui || 0,
    pointsMer: item.pointsMer || 0,
    pointsFuhua: item.pointsFuhua || 0,
    shares: item.shares || 0,
    couponType: item.couponType || '',
    couponValue: item.couponValue || '',
    couponIsTransferable: item.couponIsTransferable == 1 ? '1' : '0',
    isBaodan: item.isBaodan || false,
    directBuy: item.directBuy || false,
    enableVip: item.enableVip || false,
    supplierId: item.supplierId || 0,
    sectionId: item.sectionId || null, // 优选区
    brandId: item.brandId || null, // 优选区
    from: item.from || null, // 来源
    sourceId: item.sourceId || null, // 来源
    skuId: item.skuId || null, //
    // 支付途径限制位掩码：0=不限制 CASH=1 QXJ=2 XFQ=4 DHQ=8
    allowedPayMethods: item.allowedPayMethods ?? 1,
    // 权益金支付白名单/黑名单
    qxjWhitelist: item.qxjWhitelist || '0',
    qxjBlacklist: item.qxjBlacklist || '',
    // 赠送权益配置（展开存储，方便表单绑定）
    rc_systemPool: item.rewardConfig?.systemPool ?? '',
    rc_pintuanPool: item.rewardConfig?.pintuanPool ?? '',
    rc_jytCoin: item.rewardConfig?.jytCoin ?? '',
    rc_jytScore: item.rewardConfig?.jytScore ?? '',
    rc_jytEquity: item.rewardConfig?.jytEquity ?? '',
    rc_directRewardEnabled: item.rewardConfig?.directReward?.enabled ?? false,
    rc_directRewardRatio: item.rewardConfig?.directReward?.ratio ?? 0.1,
    // 免签会员天数 / 金银通会员天数
    rc_superVipDays: item.rewardConfig?.superVipDays ?? '',
    rc_goldVipDays: item.rewardConfig?.goldVipDays ?? '',
  });

  useEffect(() => {
    getProductCategories();
    getSuppliers();
    getStoreSections();
    getStoreBrands();
    if (item.coupons) {
      getCoupons();
    }
  }, []);
  useEffect(() => {
    if (!suppliers.length) return;
    let param = [{
      name: '文金券',
      id: 'unlockWjt'
    }, {
      name: '激活券',
      id: 'unlock'
    }]
    let paramTwo = [{
      name: '不可转让',
      id: '0'
    }, {
      name: '可转让',
      id: '1'
    }]
    setSupplier(suppliers.find(sup => sup.id == form.supplierId) || {})
    setCategoryList(param)
    setTransferList(paramTwo)
  }, [suppliers]);
  // 分类初始化
  useEffect(() => {
    if (categoriesNew.length === 0) return;

    const getFirstSub = (parentId) =>
      categoriesNew.find(cat => cat.level === 1 && cat.pid === parentId);

    if (action === 'edit' && item.subCategoryId) {
      // 编辑且有 subCategoryId：反推父级
      const subCat = categoriesNew.find(cat => cat.id == item.subCategoryId);
      const parentCat = subCat && categoriesNew.find(cat => cat.id === subCat.pid);
      setFilter({
        categoryId: parentCat ? String(parentCat.id) : "",
        subCategoryId: subCat ? String(subCat.id) : ""
      });
    } else if (action === 'edit' && item.categoryId) {
      // 编辑只有 categoryId：选该分类下第一个子分类
      const cat = categoriesNew.find(c => c.id == item.categoryId);
      if (cat) {
        const firstSub = getFirstSub(cat.id);
        setFilter({
          categoryId: String(cat.id),
          subCategoryId: firstSub ? String(firstSub.id) : ""
        });
      }
    } else {
      // 添加模式：选第一个一级分类下的第一个子分类
      const firstParent = categoriesNew.find(cat => cat.level === 0);
      if (firstParent) {
        const firstSub = getFirstSub(firstParent.id);
        setFilter({
          categoryId: String(firstParent.id),
          subCategoryId: firstSub ? String(firstSub.id) : ""
        });
      }
    }
  }, [categoriesNew]);

  // 搜索过滤分类
  const filteredCategories = useMemo(() => {
    if (!categorySearch.trim()) {
      return categoriesNew;
    }

    const searchTerm = categorySearch.toLowerCase();
    return categoriesNew.filter(category =>
      category.name.toLowerCase().includes(searchTerm) ||
      category.displayName.toLowerCase().includes(searchTerm)
    );
  }, [categoriesNew, categorySearch]);

  async function getProductCategories() {
    try {
      const response = await axios.get("/store/category/all");
      const {code, data} = response.data;
      if (code === 1) {
        const buildTree = (items, parentId = 0, level = 0) => {
          return items
            .filter(item => item.pid === parentId)
            .sort((a, b) => b.order - a.order)
            .flatMap(item => [
              {
                ...item,
                level,
                displayName: `${"─".repeat(level * 2)} ${item.name}`.trimStart()
              },
              ...buildTree(items, item.id, level + 1)
            ]);
        };
        setCategoriesNew(buildTree(data));
      }
    } catch (err) {
      console.error("获取分类失败:", err);
    }
  };

  async function getCoupons() {
    const {data} = await asyncRequest({
      path: "/coupon/query",
      data: {ids: item.coupons.split(",")},
    });

    setCoupons(data);
  }

  function handleIptChange(ki, val) {
    setForm({
      ...form,
      [ki]: val,
    });
  }

  function handlePriceListChange(obj) {
    setForm({
      ...form,
      ...obj,
    });
  }

  async function handleSubmit() {
    const {specType, attrs, priceList} = form;
    // 支付方式必须包含现金支付（CASH=1）
    if ((form.allowedPayMethods & 1) === 0) {
      alert("支付方式至少需要勾选「现金支付」", "warning");
      return;
    }
    form.categoryId = filter.categoryId;
    form.subCategoryId = filter.subCategoryId;
    // 组装 rewardConfig：只有有值的字段才写入
    const rewardConfig = {};
    if (form.rc_systemPool !== '' && form.rc_systemPool != null) rewardConfig.systemPool = parseFloat(form.rc_systemPool);
    if (form.rc_pintuanPool !== '' && form.rc_pintuanPool != null) rewardConfig.pintuanPool = parseFloat(form.rc_pintuanPool);
    if (form.rc_jytCoin !== '' && form.rc_jytCoin != null) rewardConfig.jytCoin = parseFloat(form.rc_jytCoin);
    if (form.rc_jytScore !== '' && form.rc_jytScore != null) rewardConfig.jytScore = parseFloat(form.rc_jytScore);
    if (form.rc_jytEquity !== '' && form.rc_jytEquity != null) rewardConfig.jytEquity = parseFloat(form.rc_jytEquity);
    if (form.rc_directRewardEnabled) {
      rewardConfig.directReward = { enabled: true, ratio: parseFloat(form.rc_directRewardRatio) || 0.1 };
    }
    if (form.rc_superVipDays !== '' && form.rc_superVipDays != null) rewardConfig.superVipDays = parseInt(form.rc_superVipDays) || 0;
    if (form.rc_goldVipDays !== '' && form.rc_goldVipDays != null) rewardConfig.goldVipDays = parseInt(form.rc_goldVipDays) || 0;

    const formData = {
      ...form,
      mid: merchant.mid,
      detail,
      attrs: specType === 1 ? StringUtil.serialize(attrs) : null,
      priceList: specType === 1 ? StringUtil.serialize(priceList) : null,
      coupons: coupons.map((c) => c.id).join(","),
      supplyChainFee: form.supplyChainFee !== "" && form.supplyChainFee !== undefined ? form.supplyChainFee : 0,
      rewardConfig: Object.keys(rewardConfig).length > 0 ? rewardConfig : null,
      // 权益金支付黑白名单
      qxjWhitelist: form.qxjWhitelist || null,
      qxjBlacklist: form.qxjBlacklist || null,
    };

    if (action == "edit") {
      formData.id = id;
    }

    await asyncRequest({
      path: action == "edit" ? "/store/product/edit" : "/store/product/add",
      data: formData,
    });

    onFinish();
  }

  function handleSelectMerchant(key) {
    MerchantPicker({
      onSelect(val) {
        setMerchant(val);
      },
    });
  }

  function handleSelectSupplier() {
    SupplierPicker({
      onSelect(val) {
        setSupplier(val)
        handleIptChange('supplierId', val.id)
      }
    })
  }

  function handleSelectCoupon() {
    CouponPicker({
      title: "优惠券列表",
      onSelect(val) {
        setCoupons(val);
      },
    });
  }

  return (
    <FormDialog open={open} title={`${action == "edit" ? "编辑" : "添加"}商品`} onClose={onClose}
                onConfirm={handleSubmit} contentStyle={{width: "66vw", minWidth: "375px", height: "80vh"}}>
      <TabContext value={tabIdx}>
        <Box sx={{borderBottom: 1, borderColor: "divider"}}>
          <TabList onChange={(e, idx) => setTabIdx(idx)}>
            {TABS.map((t, idx) => (
              <Tab key={t.label} label={t.label} value={String(idx)}/>
            ))}
          </TabList>
        </Box>
        <TabPanel value="0">
          <FormItem title="商户" required>
            <TextField fullWidth placeholder="请选择商户" autoComplete="off" id="merchant" value={merchant.name || ""}
                       size="small" onClick={() => handleSelectMerchant("mid")}/>
          </FormItem>

          <FormItem title="商品分类">
            <Select
              label="商品分类"
              value={filter.subCategoryId || filter.categoryId || ""}
              style={{width: 250, height: 44, paddingLeft: 16}}
              onChange={(e) => {
                const selectedId = e.target.value;

                if (!selectedId) {
                  setFilter(prev => ({...prev, categoryId: "", subCategoryId: ""}));
                  setCategorySearch('');
                  return;
                }

                const selectedCategory = categoriesNew.find(cat => cat.id === Number(selectedId));

                if (selectedCategory?.level === 0) {
                  setFilter(prev => ({...prev, categoryId: selectedId, subCategoryId: ""}));
                } else if (selectedCategory?.level === 1) {
                  const parentCategory = categoriesNew.find(cat => cat.id === selectedCategory.pid);
                  setFilter(prev => ({
                    ...prev,
                    categoryId: parentCategory ? String(parentCategory.id) : "",
                    subCategoryId: selectedId
                  }));
                } else {
                  setFilter(prev => ({...prev, categoryId: "", subCategoryId: ""}));
                }

                setCategorySearch('');
                setOpenCategorySelect(false);
              }}
              open={openCategorySelect}
              onOpen={() => {
                setOpenCategorySelect(true);
                setCategorySearch('');
              }}
              onClose={() => {
                setOpenCategorySelect(false);
                setCategorySearch('');
              }}
              MenuProps={{
                PaperProps: {style: {maxHeight: 300}},
                disableAutoFocusItem: true,
                MenuListProps: {autoFocus: false}
              }}
              renderValue={(selected) => {
                if (!selected) return "全部";
                const selectedCategory = categoriesNew.find(cat =>
                  cat.id === Number(selected)
                );
                return selectedCategory ? selectedCategory.displayName : "请选择分类";
              }}
            >
              <div
                style={{
                  padding: '8px 16px',
                  borderBottom: '1px solid #e0e0e0',
                  position: 'sticky',
                  top: 0,
                  backgroundColor: 'white',
                  zIndex: 1
                }}
                onClick={(e) => e.stopPropagation()} // 阻止点击事件冒泡
              >
                <TextField
                  size="small"
                  placeholder="搜索分类..."
                  fullWidth
                  variant="outlined"
                  value={categorySearch}
                  onChange={(e) => {
                    setCategorySearch(e.target.value);
                  }}
                  onKeyDown={(e) => {
                    // 阻止回车键关闭下拉
                    if (e.key === 'Enter') {
                      e.stopPropagation();
                    }
                  }}
                  autoFocus
                />
              </div>

              <MenuItem value="">全部</MenuItem>

              {filteredCategories.length === 0 ? (
                <MenuItem disabled>
                  <Typography color="textSecondary" style={{fontStyle: 'italic'}}>
                    未找到匹配的分类
                  </Typography>
                </MenuItem>
              ) : (
                filteredCategories.map(category => (
                  <MenuItem
                    key={category.id}
                    value={String(category.id)}
                    style={{
                      paddingLeft: 20 + category.level * 20,
                      fontWeight: category.level === 0 ? 'bold' : 'normal',
                      backgroundColor: category.level === 0 ? '#f5f5f5' : 'transparent'
                    }}
                  >
                    {category.displayName}
                  </MenuItem>
                ))
              )}
            </Select>
          </FormItem>

          <FormItem title="所属专区">
            <Select value={form.sectionId} onChange={(e) => handleIptChange("sectionId", e.target.value)}
                    style={{width: 250, height: 44}}>
              {storeSections.map((item, idx) => (
                <MenuItem key={item.id} value={item.id} name={item.name}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormItem>

          <FormItem title="所属品牌">
            <Select value={form.brandId} onChange={(e) => handleIptChange("brandId", e.target.value)}
                    style={{width: 250, height: 44}}>
              {storeBrands.map((item, idx) => (
                <MenuItem key={item.id} value={item.id} name={item.name}>
                  {item.name}
                </MenuItem>
              ))}
            </Select>
          </FormItem>

          <FormItem title="商品名称" required>
            <TextField fullWidth placeholder="请输入商品名称" autoComplete="off" id="name" value={form.name}
                       size="small" onChange={(e) => handleIptChange("name", e.target.value)}/>
          </FormItem>

          <FormItem title="商品单位" required>
            <TextField fullWidth placeholder="请输入商品单位" autoComplete="off" id="unit" value={form.unit}
                       size="small" onChange={(e) => handleIptChange("unit", e.target.value)}/>
          </FormItem>

          <FormItem title="商品封面" required>
            <Stack>
              <Uploader images={form.cover} onUploaded={(val) => handleIptChange("cover", val)}/>
              <Typography mt={2} fontSize={14} color="gray">
                建议尺寸：800x800
              </Typography>
            </Stack>
          </FormItem>
          {/*
              <FormItem title="横向封面">
                <Stack>
                  <Uploader images={form.coverHorizontal} onUploaded={(val) => handleIptChange("coverHorizontal", val)} />
                  <Typography mt={2} fontSize={14} color="gray">
                    建议尺寸：320x180
                  </Typography>
                </Stack>
              </FormItem> */}

          <FormItem title="商品轮播图" required>
            <Stack>
              <Uploader multiple images={form.images} onUploaded={(val) => handleIptChange("images", val)}/>
              <Typography mt={2} fontSize={14} color="gray">
                建议尺寸：800x800
              </Typography>
            </Stack>
          </FormItem>

          <FormItem title="商品详情图" required>
            <Stack>
              <Uploader multiple images={form.detailImages} onUploaded={(val) => handleIptChange("detailImages", val)}/>
            </Stack>
          </FormItem>

          <FormItem title="商品状态" required>
            <RadioGroup row aria-label="gender" name="row-radio-buttons-group" value={form.status}>
              <FormControlLabel value={1} control={<Radio/>} label="上架"
                                onChange={(e) => handleIptChange("status", e.target.value)}/>
              <FormControlLabel value={0} control={<Radio/>} label="下架"
                                onChange={(e) => handleIptChange("status", e.target.value)}/>
            </RadioGroup>
          </FormItem>

          <FormItem title="适用群体">
            <Stack direction="row">
              <FormControlLabel control={<Checkbox checked={form.isRetail}
                                                   onChange={(e) => handleIptChange("isRetail", e.target.checked)}/>}
                                label="零售"/>
              <FormControlLabel control={<Checkbox checked={form.isBulk}
                                                   onChange={(e) => handleIptChange("isBulk", e.target.checked)}/>}
                                label="批发"/>
            </Stack>
          </FormItem>

          {/* <FormItem title="供应商">
            <Select value={form.supplierId} onChange={(e) => handleIptChange("supplierId", e.target.value)} style={{ width: 250, height: 44 }}>
              {suppliers
                .filter((c) => c.status)
                .map((supplier) => (
                  <MenuItem key={supplier.id} value={supplier.id} name={supplier.name}>
                    {supplier.name}
                  </MenuItem>
                ))}
            </Select>
          </FormItem> */}

          <FormItem title="供应商" required>
            <TextField fullWidth placeholder="请选择供应商" autoComplete="off" id="supplier" value={supplier.name || ""}
                       size="small" onClick={() => handleSelectSupplier()}/>
          </FormItem>

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

        <TabPanel value="1">
          <FormItem title="商品库存" required>
            <TextField fullWidth type="number" placeholder="请输入商品库存，不填则无限" autoComplete="off" id="stock"
                       value={form.stock} size="small" onChange={(e) => handleIptChange("stock", e.target.value)}/>
          </FormItem>

          <FormItem title="商品规格" required>
            <RadioGroup row name="row-radio-buttons-group" value={form.specType}
                        onChange={(e) => handleIptChange("specType", parseInt(e.target.value))}>
              <FormControlLabel value={0} control={<Radio/>} label="单规格"/>
              <FormControlLabel value={1} control={<Radio/>} label="多规格"/>
            </RadioGroup>
          </FormItem>

          {form.specType === 0 && (
            <>
              <FormItem title="平台划线价">
                <TextField fullWidth type="number" placeholder="请输入平台显示的划线价" autoComplete="off"
                           id="priceOriginal"
                           value={form.priceOriginal} size="small"
                           onChange={(e) => handleIptChange("priceOriginal", e.target.value)}/>
              </FormItem>

              <FormItem title="供货商成本价" required>
                <TextField fullWidth type="number" placeholder="请输入供货商成本价" autoComplete="off" id="supplierCost"
                           value={form.supplierCost} size="small"
                           onChange={(e) => handleIptChange("supplierCost", e.target.value)}/>
              </FormItem>

              <FormItem title="平台成本价">
                <TextField fullWidth type="number" placeholder="请输入平台成本价" autoComplete="off" id="cost"
                           value={form.cost} size="small" onChange={(e) => handleIptChange("cost", e.target.value)}/>
              </FormItem>

              <FormItem title="商品售价" required>
                <TextField fullWidth type="number" placeholder="请输入商品售价" autoComplete="off" id="price"
                           value={form.price} size="small" onChange={(e) => handleIptChange("price", e.target.value)}/>
              </FormItem>
              <FormItem title="供应链服务费率" required>
                <TextField fullWidth type="number" placeholder="10%输入0.1，不填为0" autoComplete="off"
                           id="supplyChainFee" value={form.supplyChainFee === '' ? '0' : form.supplyChainFee} size="small"
                           onChange={(e) => handleIptChange("supplyChainFee", e.target.value)}/>
              </FormItem>

              {/* 净利润辅助显示 */}
              {(() => {
                const salePrice = parseFloat(form.price) || 0;
                const supplierCost = parseFloat(form.supplierCost) || 0;
                const platformCost = parseFloat(form.cost);
                const fee = parseFloat(form.supplyChainFee) || 0;
                const baseCost = !isNaN(platformCost) && platformCost > 0 ? platformCost : supplierCost;
                const profit = salePrice - baseCost - supplierCost * fee;
                if (salePrice <= 0 || supplierCost <= 0) return null;
                return (
                  <FormItem title="商品净利润">
                    <Stack direction="row" alignItems="center" spacing={1} sx={{flexWrap: 'wrap', gap: 0.5}}>
                      <Typography fontWeight="bold" fontSize={16} color={profit >= 0 ? 'success.main' : 'error.main'}>
                        ¥ {profit.toFixed(2)}
                      </Typography>
                      <Typography fontSize={11} color="text.secondary" sx={{lineHeight: 1.5}}>
                        = 售价({salePrice}) − {!isNaN(platformCost) && platformCost > 0
                          ? `平台成本(${platformCost})`
                          : `供货商成本(${supplierCost})`
                        } − 供货商成本({supplierCost}) × 服务费率({fee})
                      </Typography>
                    </Stack>
                  </FormItem>
                );
              })()}

            </>
          )}

          {form.specType === 1 && (
            <FormItem title="选择规格" required>
              <PriceList defaultAttrName={form.attrName} defaultAttrs={form.attrs} defaultPriceList={form.priceList}
                         onChange={handlePriceListChange}/>
            </FormItem>
          )}

          {/* <FormItem title="是否开启等级价格">
                <Switch checked={form.enableVip} onChange={(e) => handleIptChange("enableVip", e.target.checked)} />
              </FormItem> */}

          {/* 赠送权益分隔线 */}
          <Box sx={{mt: 3, mb: 1}}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box sx={{flex: 1, height: '1px', bgcolor: 'divider'}}/>
              <Typography variant="caption" color="text.secondary" sx={{whiteSpace: 'nowrap', px: 1}}>
                赠送权益（购买后自动赠送，留空表示不赠送）
              </Typography>
              <Box sx={{flex: 1, height: '1px', bgcolor: 'divider'}}/>
            </Stack>
          </Box>

          <FormItem title="赠送系统池金额">
            <TextField
              type="number" size="small" placeholder="留空则不赠送"
              value={form.rc_systemPool}
              onChange={(e) => handleIptChange('rc_systemPool', e.target.value)}
              inputProps={{min: 0, step: 0.01}}
            />
          </FormItem>

          <FormItem title="赠送拼团池金额">
            <TextField
              type="number" size="small" placeholder="留空则不赠送"
              value={form.rc_pintuanPool}
              onChange={(e) => handleIptChange('rc_pintuanPool', e.target.value)}
              inputProps={{min: 0, step: 0.01}}
            />
          </FormItem>

          <FormItem title="赠送金银通金豆">
            <TextField
              type="number" size="small" placeholder="留空则不赠送"
              value={form.rc_jytCoin}
              onChange={(e) => handleIptChange('rc_jytCoin', e.target.value)}
              inputProps={{min: 0, step: 0.01}}
            />
          </FormItem>

          <FormItem title="赠送金银通银豆">
            <TextField
              type="number" size="small" placeholder="留空则不赠送"
              value={form.rc_jytScore}
              onChange={(e) => handleIptChange('rc_jytScore', e.target.value)}
              inputProps={{min: 0, step: 0.01}}
            />
          </FormItem>

          <FormItem title="赠送金银通权益值">
            <TextField
              type="number" size="small" placeholder="留空则不赠送"
              value={form.rc_jytEquity}
              onChange={(e) => handleIptChange('rc_jytEquity', e.target.value)}
              inputProps={{min: 0, step: 0.01}}
            />
          </FormItem>

          <FormItem title="启用直推奖励">
            <Switch
              checked={form.rc_directRewardEnabled}
              onChange={(e) => handleIptChange('rc_directRewardEnabled', e.target.checked)}
            />
          </FormItem>

          {form.rc_directRewardEnabled && (
            <FormItem title="直推奖励比例">
              <TextField
                type="number" size="small" placeholder="默认0.1即10%"
                value={form.rc_directRewardRatio}
                onChange={(e) => handleIptChange('rc_directRewardRatio', e.target.value)}
                inputProps={{min: 0, max: 1, step: 0.01}}
                helperText={`当前：${(parseFloat(form.rc_directRewardRatio) || 0) * 100}%`}
              />
            </FormItem>
          )}

          {/* VIP会员天数分隔线 */}
          <Box sx={{mt: 3, mb: 1}}>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Box sx={{flex: 1, height: '1px', bgcolor: 'divider'}}/>
              <Typography variant="caption" color="text.secondary" sx={{whiteSpace: 'nowrap', px: 1}}>
                赠送VIP会员（购买后自动赠送，留空表示不赠送）
              </Typography>
              <Box sx={{flex: 1, height: '1px', bgcolor: 'divider'}}/>
            </Stack>
          </Box>

          <FormItem title="免签会员天数">
            <TextField
              type="number" size="small" placeholder="留空则不赠送"
              value={form.rc_superVipDays}
              onChange={(e) => handleIptChange('rc_superVipDays', e.target.value)}
              inputProps={{min: 0, step: 1}}
            />
          </FormItem>

          <FormItem title="金银通会员天数">
            <TextField
              type="number" size="small" placeholder="留空则不赠送"
              value={form.rc_goldVipDays}
              onChange={(e) => handleIptChange('rc_goldVipDays', e.target.value)}
              inputProps={{min: 0, step: 1}}
            />
          </FormItem>

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

        <TabPanel value="2">
          <MyEditor
            html={detail}
            onChange={(val) => {
              setDetail(val);
            }}
          />

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

        {/* 运费设置 */}
        <TabPanel value="3">
          <FormItem title="运费设置" required>
            <RadioGroup row name="row-radio-buttons-group" value={form.shippingType}
                        onChange={(e) => handleIptChange("shippingType", parseInt(e.target.value))}>
              <FormControlLabel value={1} control={<Radio/>} label="包邮"/>
              <FormControlLabel value={2} control={<Radio/>} label="固定邮费"/>
              <FormControlLabel value={3} control={<Radio/>} label="仅限自提"/>
            </RadioGroup>
          </FormItem>

          {form.shippingType == 2 && (
            <FormItem title="">
              <TextField fullWidth placeholder="请输入固定邮费" autoComplete="off" id="shippingFee"
                         value={form.shippingFee} size="small"
                         onChange={(e) => handleIptChange("shippingFee", e.target.value)}/>
            </FormItem>
          )}

          <FormItem spacing={1}>
            <Button
              variant="contained"
              onClick={() => {
                setTabIdx(Number(tabIdx) + 1 + "");
              }}
            >
              下一步
            </Button>
          </FormItem>
        </TabPanel>

        {/* 营销 */}
        <TabPanel value="4">
          {/* <FormItem title="直推比例" required>
                <TextField
                  placeholder="请输入直推比例"
                  autoComplete="off"
                  id="zhitui"
                  value={form.zhitui}
                  size="small"
                  onChange={(e) => handleIptChange("zhitui", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment>%</InputAdornment>,
                  }}
                />
              </FormItem>
              <FormItem title="间推比例" required>
                <TextField
                  type="number"
                  placeholder="请输入间推比例"
                  autoComplete="off"
                  id="jiantui"
                  value={form.jiantui}
                  size="small"
                  onChange={(e) => handleIptChange("jiantui", e.target.value)}
                  InputProps={{
                    endAdornment: <InputAdornment>%</InputAdornment>,
                  }}
                />
              </FormItem> */}

          {/* <FormItem title="是否是报单商品">
                <Switch checked={form.isBaodan} onChange={e => handleIptChange('isBaodan', e.target.checked)} />
              </FormItem> */}

          {/* <FormItem title="直推奖励">
                <TextField type="number" placeholder="请输入直推奖励" autoComplete="off" id="zhitui" value={form.zhitui} size="small" onChange={(e) => handleIptChange("zhitui", e.target.value)} />
              </FormItem> */}

          <FormItem title="赠送绿积分">
            <TextField type="number" placeholder="请输入赠送绿积分" autoComplete="off" id="points" value={form.points}
                       size="small" onChange={(e) => handleIptChange("points", e.target.value)}/>
          </FormItem>
          <FormItem title="卡券类型">
            <Select value={form.couponType} onChange={(e) => handleIptChange("couponType", e.target.value)}
                    style={{width: 250, height: 44}}>
              {couponTypeList
                .map((supplier) => (
                  <MenuItem key={supplier.id} value={supplier.id} name={supplier.name}>
                    {supplier.name}
                  </MenuItem>
                ))}
            </Select>
          </FormItem>
          <FormItem title="转让类型">
            <Select value={form.couponIsTransferable}
                    onChange={(e) => handleIptChange("couponIsTransferable", e.target.value)}
                    style={{width: 250, height: 44}}>
              {transferList
                .map((supplier) => (
                  <MenuItem key={supplier.id} value={supplier.id} name={supplier.name}>
                    {supplier.name}
                  </MenuItem>
                ))}
            </Select>
          </FormItem>
          <FormItem title="卡券面值">
            <TextField type="number" placeholder="请输入卡券面值" autoComplete="off" id="points"
                       value={form.couponValue} size="small"
                       onChange={(e) => handleIptChange("couponValue", e.target.value)}/>
          </FormItem>

          {/* {form.sectionId == 1 && (
            <FormItem title="赠送福利积分">
              <TextField type="number" placeholder="请输入赠送福利积分" autoComplete="off" id="pointsFuhua" value={form.pointsFuhua} size="small" onChange={(e) => handleIptChange("pointsFuhua", e.target.value)} />
            </FormItem>
          )} */}

          {/* <FormItem title="赠送商户积分">
                <TextField type="number" placeholder="请输入赠送商户积分，不填默认同用户积分" autoComplete="off" id="pointsMer" value={form.pointsMer} size="small" onChange={(e) => handleIptChange("pointsMer", e.target.value)} />
              </FormItem> */}

          <FormItem title="排序">
            <TextField placeholder="数字越大越靠前" type="number" autoComplete="off" id="order" value={form.order}
                       size="small" onChange={(e) => handleIptChange("order", e.target.value)}/>
          </FormItem>

          <FormItem title="是否精选">
            <Switch checked={form.isSelected} onChange={(e) => handleIptChange("isSelected", e.target.checked)}/>
          </FormItem>

          <FormItem title="赠送优惠券">
            <Stack>
              {coupons.map((c, i) => (
                <Typography key={i}>{c.name}</Typography>
              ))}
              <Button variant="contain" color="primary" onClick={handleSelectCoupon}>
                添加优惠券
              </Button>
            </Stack>
          </FormItem>

          <FormItem>
            <Button variant="contained" type="submit" onClick={handleSubmit}>
              确认{id ? "修改" : "添加"}
            </Button>
          </FormItem>
        </TabPanel>

        {/* 支付方式 */}
        <TabPanel value="5">
          <FormItem title="允许的支付方式">
            <Stack spacing={1}>
              {[
                {label: '现金支付（快捷支付）', bit: 1, desc: 'CASH=1'},
                {label: '权益金支付', bit: 2, desc: 'QXJ=2'},
                {label: '消费券抵扣', bit: 4, desc: 'XFQ=4'},
                {label: '兑换券支付', bit: 8, desc: 'DHQ=8'},
              ].map(({label, bit, desc}) => (
                <FormControlLabel
                  key={bit}
                  label={
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography>{label}</Typography>
                      <Typography fontSize={12} color="gray">{desc}</Typography>
                    </Stack>
                  }
                  control={
                    <Checkbox
                      checked={(form.allowedPayMethods & bit) !== 0}
                      onChange={(e) => {
                        const next = e.target.checked
                          ? form.allowedPayMethods | bit
                          : form.allowedPayMethods & ~bit;
                        handleIptChange('allowedPayMethods', next);
                      }}
                    />
                  }
                />
              ))}
            </Stack>
            <Typography fontSize={12} color="gray" mt={1}>
              当前位掩码值：<strong>{form.allowedPayMethods}</strong>（0 表示不限制）
            </Typography>
          </FormItem>

          {/* 权益金支付白名单/黑名单 - 仅在勾选权益金支付时显示 */}
          {(form.allowedPayMethods & 2) !== 0 && (
            <>
              <Box sx={{mt: 3, mb: 1}}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Box sx={{flex: 1, height: '1px', bgcolor: 'divider'}}/>
                  <Typography variant="caption" color="text.secondary" sx={{whiteSpace: 'nowrap', px: 1}}>
                    权益金支付黑白名单
                  </Typography>
                  <Box sx={{flex: 1, height: '1px', bgcolor: 'divider'}}/>
                </Stack>
              </Box>

              <FormItem title="白名单UID">
                <TextField
                  fullWidth
                  placeholder="默认0表示所有人可用，多个UID以逗号分隔"
                  autoComplete="off"
                  id="qxjWhitelist"
                  value={form.qxjWhitelist}
                  size="small"
                  onChange={(e) => handleIptChange("qxjWhitelist", e.target.value)}
                  helperText="白名单为0时所有人可用；非0时仅白名单UID可用"
                />
              </FormItem>

              <FormItem title="黑名单UID">
                <TextField
                  fullWidth
                  placeholder="留空表示无黑名单，多个UID以逗号分隔"
                  autoComplete="off"
                  id="qxjBlacklist"
                  value={form.qxjBlacklist}
                  size="small"
                  onChange={(e) => handleIptChange("qxjBlacklist", e.target.value)}
                  helperText="黑名单优先级高于白名单，黑名单内UID不可使用权益金支付"
                />
              </FormItem>
            </>
          )}
        </TabPanel>

      </TabContext>
    </FormDialog>
  );
}
